//import $ from 'jquery';

const
  NAME               = 'fixedColumn',
  VERSION            = '1.0.0',
  JQUERY_NO_CONFLICT = $.fn[NAME]
;

class Fixedcolumn {
  constructor(element$) {
    this._element$ = element$;
    let fixedcolumn = element$.clone().insertBefore(element$).addClass('fixed-column');
    fixedcolumn.find('th:not(:first-child),td:not(:first-child)').remove();
    fixedcolumn.find('tr').each(function (i) {
      $(this).height(element$.find('tr:eq(' + i + ')').height());
    });
  }

  static get VERSION() {
    return VERSION;
  }

  static _jQueryInterface(/*config*/) {
    return this.each(function() {
      new Fixedcolumn($(this));
    });
  }
}

$.fn[NAME]             = Fixedcolumn._jQueryInterface;
$.fn[NAME].Constructor = Fixedcolumn;
$.fn[NAME].noConflict  = function noConflict() {
  $.fn[NAME] = JQUERY_NO_CONFLICT;
  return Fixedcolumn._jQueryInterface;
};

export default Fixedcolumn;



// WEBPACK FOOTER //
// ./src/plugins/fixed-column.js